const options = {
  5: "bg-teal-100/5",
  10: "bg-teal-100/10",
  25: "bg-teal-100/25",
  50: "bg-teal-100/50",
  75: "bg-teal-100/75",
  90: "bg-teal-100/90",
  100: "bg-teal-100",
};

const from = {
  5: "from-teal-100/5",
  10: "from-teal-100/10",
  25: "from-teal-100/25",
  50: "from-teal-100/50",
  75: "from-teal-100/75",
  90: "from-teal-100/90",
  100: "from-teal-100",
};

export default function getBackgroundTeal100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
